import { render, staticRenderFns } from "./ed-scan-images-viewer.component.vue?vue&type=template&id=de210896&scoped=true&"
import script from "./ed-scan-images-viewer.component.ts?vue&type=script&lang=js&"
export * from "./ed-scan-images-viewer.component.ts?vue&type=script&lang=js&"
import style0 from "./ed-scan-images-viewer.component.scss?vue&type=style&index=0&id=de210896&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de210896",
  null
  
)

export default component.exports